// extracted by mini-css-extract-plugin
module.exports = {"list":"WorkspaceParticipiantsModalAddExistingPeopleList_list__nYjGT"};